(function($) {

	'use strict';

	var init = function() {
        closePopup();
	};

    var closePopup = function() {
        $('.tiles-prob__close').on('click', function(e){
            e.preventDefault();
            $('.tiles-prob.homepage').animate({top: "-=400px"}, '1s');
        })
    }

	
	$(document).ready(function() {
		init();
	});

})(jQuery);
